import React, { useContext } from "react";
import { Menu } from "antd";
import { AppContext } from "../../contexts/global";
import "antd/dist/antd.css";
import { validateDirectivas } from "../../utils/utils";
export default function Wrapper({ element }) {
  const { directivas } = useContext(AppContext);
  return (
    <>
      {validateDirectivas(directivas,element.props.id) && (
        <Menu.Item key={element.key} id={element.props.id} icon={element.props.icon?element.props.icon:''}>
          {element.props.children}
        </Menu.Item>
      )}
    </>
  );
}
